import { Component, OnInit, OnChanges, SimpleChanges, HostListener, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Platform } from '@ionic/angular';
import { ServiceService } from '../mastermodule/service/service.service';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, OnChanges {
  sideBarPinned: boolean = true;
  // sideBarPinned: boolean = false;

  nav_loading = true

  key_session = '';
  user_name = '';
  user_type = '';
  isOpen: boolean = false;
  isActive: any;
  // privilage_array = [];
  NAME_OF_USER = '';

  head_variable: any;
  nav_logo_src = ''

  isIframe = false

  constructor(
    private storage: Storage,
    private api: ServiceService,
    public platform: Platform,
    private router: Router,
    private cookies: CookieService,
    private renderer: Renderer2,
    private elRef: ElementRef
  ) {

    // use this onely if you want to mantain the pined state by default
   
 

    this.key_session = this.api.get_session_id_login();

    if (this.key_session != '' && this.key_session != null) {
      this.user_name = this.api.get_user_details_in_cookies();
    } else {
      this.router.navigate(['/mod0101']);
    }
    this.api.verify_cur_loading_pg_privilege();

    this.get_privilage_function();
    $('#user_icon').attr('value', '1');

    this.user_type = this.api.localStorage.getItem('user_type');
  }

  ngOnChanges(changes: SimpleChanges): void {}

  ngOnInit() {
    this.load_nav_logo()
    this.api.get_website_colour()


    this.head_variable = this.api.getSharedData();
    this.user_type = this.api.localStorage.getItem('user_type')

    $('.HideUser').hide();

    this.NAME_OF_USER = this.api.localStorage.getItem('user_name')

   if(this.api.localStorage.getItem("sideBarPinned")=="true"){
    // $(".navbar_header").css("color", "#6C0BA9");
    this.sideBarPinned = true;
    $(".navbar_header").css("margin-left", "13em");
  }else{
    // $(".navbar_header").css("color", "#6C0BA9");
    $(".navbar_header").css("margin-left", "-13em");
    this.sideBarPinned = false

  }

    if (this.sideBarPinned) {
      $('.sidebar-wrapper').addClass('pinned-sidebar');
      $('ion-content body').addClass('sidebar-pinned');
    } else {
      $('.sidebar-wrapper').removeClass('pinned-sidebar');
      $('ion-content body').removeClass('sidebar-pinned');

      // sets navbar closed at instance.
      this.navbarOpenClose(false);
      // set the cards closed at instance.
      $('.sidebar-submenu').slideUp(200);

    }

    this.previewMenubar()

    this.checkIframe()
  }


  load_nav_logo()
  {
    const imageElement = document.getElementById(
      'nav_logo'
    ) as HTMLImageElement;

    var cmp_logo = this.api.localStorage.getItem('cmp_logo')
    var media_url = this.api.localStorage.getItem('media_url')

    // Create a URL for the image blob using createObjectURL

    this.nav_logo_src = environment.API_URL + media_url + '/' + cmp_logo;
    // const imageURL =
    //   environment.API_URL + media_url + '/' + cmp_logo2;
    // // Set the 'src' attribute of the <img> element to the URL
    // imageElement.src = imageURL;
  }

  checkIframe()
  {
    if ( window !== window.parent ) 
    {
      this.isIframe = true
    }
  }

  previewMenubar(){
    if(this.api.localStorage.getItem("sideBarPinned")=="false")
    {
        // this.navbarOpenClose(false,false)
        this.sideBarPinned=false
        this.openCloseSubmenuWithTimeout();
        this.openCloseSubmenuWithTimeoutMainmenu();
    }
    if(this.api.localStorage.getItem("sideBarPinned")=="true")
    {
      this.navbarOpenClose(true,true)
      this.sideBarPinned=true
      $(".sidebar-wrapper").addClass("pinned-sidebar");
      $('ion-content body').addClass('sidebar-pinned');
      
        this.isOpen = true;
        this.isActive = ""
  
     // Call the function
           
     this.openCloseSubmenuWithTimeout();
     this.openCloseSubmenuWithTimeoutMainmenu();
  
    }
  }

  openCloseSubmenuWithTimeoutMainmenu() {
    setTimeout(() => {
      this.submenuOpenClose(
          this.api.localStorage.getItem('submenuOpenClose_selected_mainmenu'),
          this.api.localStorage.getItem('submenuOpenClose_selected_menu_mainmenu'),         
      );

      this.isActive = "";
      this.isOpen = true;
  }, 20);

  }

  openCloseSubmenuWithTimeout() {
    
    setTimeout(() => {
        this.submenuOpenClose(
            this.api.localStorage.getItem('submenuOpenClose_selected'),
            this.api.localStorage.getItem('submenuOpenClose_selected_menu'),
        );
    
        this.isActive = "";
        this.isOpen = true;
    }, 50); // Adjust the timeout duration (in milliseconds) as needed

    setTimeout(() => {

      var selected_route3=this.api.localStorage.getItem('Navbar_Route_Node_Mainmenu')

      // $("."+ selected_route3).addClass("routeColor");
      $('.' + selected_route3)
        .addClass('routeColor')
        .siblings()
        .addClass('routeColor');

      this.isActive = "";
      this.isOpen = true;
  }, 100);


    setTimeout(() => {
      
      var selected_route2=this.api.localStorage.getItem('Navbar_Route_Node_Submenu')
       
      // $("."+ selected_route2).addClass("routeColor");
      $('.' + selected_route2)
        .addClass('routeColor')
        .siblings()
        .addClass('routeColor');
           
      this.isActive = "";
      this.isOpen = true;
  }, 100);

    setTimeout(() => {
      
      var selected_route1=this.api.localStorage.getItem('Navbar_Route_Node')
      // var selected_route2=this.api.localStorage.getItem('Navbar_Route_Node_Submenu')
    
  
      // $("."+ selected_route1).addClass("routeColor");

      $('.' + selected_route1)
      .addClass('routeColor')
      .siblings()
      .addClass('routeColor');
           
      this.isActive = "";
      this.isOpen = true;
  }, 100);
   
}

 // get a page follow form privilage

  get_privilage_function() {
    this.api.get_privilage_function(() => {
      this.previewMenubar();
      this.nav_loading = false;
    });
  }

  navbarOpenClose(open: boolean, clickTrigger: boolean = false) {
    if (open) {
      $('.page-wrapper').addClass('toggled');
      this.isOpen = false;

    } else {
      $('.page-wrapper').removeClass('toggled');
      this.isOpen = true;

      if (clickTrigger) {
        $('.sidebar-wrapper').removeClass('pinned-sidebar');
        $('ion-content body').removeClass('sidebar-pinned');
        this.api.localStorage.setItem('sideBarPinned', 'false');
        this.sideBarPinned = false;
      }
    }
  }

  submenuOpenClose(selected: any, selected_menu: any) 
  {
    
    if(selected_menu=="mainmenu")
    {

      this.api.localStorage.setItem('submenuOpenClose_selected_mainmenu',selected)
      this.api.localStorage.setItem('submenuOpenClose_selected_menu_mainmenu',selected_menu)

    }
    else
    {

    this.api.localStorage.setItem('submenuOpenClose_selected',selected)
    this.api.localStorage.setItem('submenuOpenClose_selected_menu',selected_menu)

    }
    
    // check whether the card is active(open).
    var submenu = '.submenu-' + selected;
    var dropdown = '.dropdown-' + selected;

    if ($(dropdown).hasClass("active")) {
 
      // if active - close the card and remove class active.
      $(submenu).slideUp(200);
      $(dropdown).removeClass('active');
      // $(submenu).parent().removeClass("active");
    } else {
      // if not active - open the card and add class active

      // close all the other tabs and removes class active from all other.

      if (this.isOpen == true) {
        if (this.isActive == selected) {
     
          $(dropdown).find(submenu).slideUp(200);
          this.isOpen = false;
          this.isActive = '';
        } else {
    
          this.isActive = ""

          if (selected_menu == "mainmenu") {
   
            $(dropdown).find(submenu).slideDown(200);
            $(dropdown).parent().addClass('active');

            $('.sidebar-submenu:not(' + submenu + ')').slideUp(200);
            $('.sidebar-submenu-new:not(' + submenu + ')').slideUp(200);
            $('.sidebar-dropdown:not(' + dropdown + ')').removeClass('active');
            this.isActive = selected;
            this.isOpen = true;
          } else {
     
            $(dropdown).find(submenu).slideDown(200);
            $(dropdown).parent().addClass('active');

            $('.sidebar-submenu-new:not(' + submenu + ')').slideUp(200);
            $('.sidebar-dropdown:not(' + dropdown + ')').removeClass('active');

            this.isActive = selected;
            this.isOpen = true;
          }
        }

      } 
      else {

        if (selected_menu == "mainmenu") {

          $(dropdown).find(submenu).slideDown(200);
          $(dropdown).parent().addClass('active');

          $('.sidebar-submenu:not(' + submenu + ')').slideUp(200);
          $('.sidebar-submenu-new:not(' + submenu + ')').slideUp(200);
          $('.sidebar-dropdown:not(' + dropdown + ')').removeClass('active');
          this.isActive = selected;
          this.isOpen = true;
        } else {
          $(dropdown).find(submenu).slideDown(200);
          $(dropdown).parent().addClass('active');

          $('.sidebar-submenu-new:not(' + submenu + ')').slideUp(200);
          $('.sidebar-dropdown:not(' + dropdown + ')').removeClass('active');

          this.isActive = selected;
          this.isOpen = true;
        }
      }
    }
  }

  navigate(route: any) {
    if (!this.sideBarPinned) this.navbarOpenClose(false);
    $('.sidebar-submenu').slideUp(200);
    $('.sidebar-dropdown').removeClass('active');
    this.router.navigate([route], { replaceUrl: true });
    
  }

  logout() {
    this.api.localStorage.removeItem('token');
    this.api.localStorage.removeItem('user_name');
    this.router.navigate(['/loginpage'])
    this.api.saved_nav_stack  = [];
  }

  togglePinSidebar(selectedtype: any) {
    let sideBarPinned = $('.sidebar-wrapper').hasClass('pinned-sidebar');

    let isMobile = window.innerWidth < 768;
    if (sideBarPinned || isMobile) {
      $('.sidebar-wrapper').removeClass('pinned-sidebar');
      $('ion-content body').removeClass('sidebar-pinned');
      $('.navbar_header').removeClass('sidebar-pinned');
      // this.api.localStorage.setItem('sideBarPinned', 'false');
      this.api.localStorage.setItem('sideBarPinned', 'false');
    } else {
      $('.sidebar-wrapper').addClass('pinned-sidebar');
      $('ion-content body').addClass('sidebar-pinned');
      $('.navbar_header').addClass('sidebar-pinned');
      // this.api.localStorage.setItem('sideBarPinned', 'true');
      this.api.localStorage.setItem('sideBarPinned', 'true');
    }
  
    // this.sideBarPinned = !sideBarPinned;

    if(sideBarPinned){
    
      // $(".navbar_header").css("color", "#6C0BA9");
      $(".navbar_header").css("margin-left", "-13em");
      this.api.localStorage.setItem('sideBarPinned', 'false');
      this.sideBarPinned = false
    }
    else{
      // $(".navbar_header").css("color", "#6C0BA9");
      $(".navbar_header").css("margin-left", "13em");
      this.api.localStorage.setItem('sideBarPinned', 'true');
      this.sideBarPinned = true
    }

  }
 
  
  ShowUserProfile()
  {

    if($("#user_icon").attr('value')=='0')
    {
      $(".HideUser").hide()
      $("#user_icon").attr('value','1')
    }
    else
    {
      $(".HideUser").show()
      $("#user_icon").attr('value','0')
    }
  }

  // @ViewChild('myDiv') myDiv: ElementRef;

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    if ($(event.target).is('ion-content :not(.sidebar-pinned)')) {
      if(!this.sideBarPinned){
        this.navbarOpenClose(false)
      }
      
    }

    if ($(event.target).is('ion-header:not(.HideUser)')) {
      $('.HideUser').hide();
      $('#user_icon').attr('value', '1');
    }

    if (!this.elRef.nativeElement.contains(event.target)) {
      // if ($(event.target).is('ion-content body:not(.sidebar-pinned)')) {
      //   this.navbarOpenClose(false)
      //   $('.HideUser').hide();
      // }

      if ($(event.target) != 'not(.HideUser)') {
        $('.HideUser').hide();
        $('#user_icon').attr('value', '1');
      }

      // Clicked outside the div, so hide it
      // this.renderer.setStyle(this.elRef.nativeElement, 'display', 'none');
    }
  }
  clickRouteNode(routeclass){
    this.api.localStorage.setItem("Navbar_Route_Node",routeclass)
  }

  clickRouteNodeSubmenu(routeclass_submenu){
    this.api.localStorage.setItem("Navbar_Route_Node_Submenu",routeclass_submenu)
  }
  clickRouteNodeMainmenu(routeclass_mainmenu){
    this.api.localStorage.setItem("Navbar_Route_Node_Mainmenu",routeclass_mainmenu)
  }
  mainmenuWithNoSubmenu()
  {
      this.api.localStorage.setItem('submenuOpenClose_selected_mainmenu',"");
      this.api.localStorage.setItem('submenuOpenClose_selected_menu_mainmenu',"");
      this.api.localStorage.setItem("Navbar_Route_Node_Submenu","")
      this.api.localStorage.setItem("Navbar_Route_Node","")
  }

  routeNodeinSubmenu()
  {
    this.api.localStorage.setItem('submenuOpenClose_selected',"");
    this.api.localStorage.setItem('submenuOpenClose_selected_menu',"");
    this.api.localStorage.setItem("Navbar_Route_Node","")
  }

  checkPrivilageArrayOr(arr) {

    if (arr[0] == '0')
    {
      return true
    }
    else{
      return arr.some((x) => this.api.privilage_array.includes(x));
    }

  }
}
